import React from 'react'
import { FaLinkedin } from 'react-icons/fa'
import { FaGithub } from 'react-icons/fa'

const HeaderSocials = () => {
  return (
    <div className='header_socials'>
      <a href="https://www.linkedin.com/in/angelat603" target="_blank" rel="noreferrer">
        <FaLinkedin />
      </a>
      <a href="https://github.com/AngelaTTTTT" target="_blank" rel="noreferrer">
        <FaGithub />
      </a>
    </div>
  )
}

export default HeaderSocials
